<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="10" offset="1" v-if="content">
        <exercise-logic
          exCollection="museumExCollection"
          :saveState="saveState"
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          :doc="doc"
          :shared="false"
        >
          <template slot-scope="{ saveExercise }">
            <v-card light>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <h1 class="text-h4 black--text">
                      {{ content.exercise_museum.step1.title }}
                    </h1></v-col
                  >
                  <v-col cols="4" class="mb-4">
                    <p
                      v-for="(item, index) in content.exercise_museum.step1
                        .description"
                      :key="index"
                      v-text="item"
                      class="black--text"
                      :class="index === 0 ? 'title' : 'text-body-1'"
                    />
                  </v-col>
                  <v-col cols="8" class="">
                    <museum-form
                      :doc="doc"
                      @save="saveExercise(true)"
                      @saveSilent="saveExercise(false)"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <bottom-navigation
              :save="true"
              :next="false"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise(true)"
            >
            </bottom-navigation>
          </template>
        </exercise-logic>
      </v-col>
    </v-row>

    <v-dialog v-if="content" v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline">{{
          content.exercise_museum.saved.title
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn
            color="amber accent-1 black--text"
            text
            :to="`/users/project/${$route.params.id}`"
          >
            Back to project
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";

import { MuseumForm } from "@/views/user/exercises/museum";

export default {
  name: "UserMuseum",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  data() {
    return {
      content: null,
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      listName: "",
      saveState: false,
      autoSave: true,
      doc: {
        title: "",
        src: "",
        emotion: "",
        power: "",
        attributes: [],
        summary: "",
      },
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    MuseumForm,
  },
  watch: {},
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    isAdmin() {
      return this.currentUser.uid === "4jd41CisaJZmDYMwCGMRhFclhXY2";
    },
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialog = true;
    },
    onLoadedEx(items) {
      this.doc = items.doc;
    },
    onSavedNext() {
      this.nextStep();
    },

    clone(obj) {
      Object.assign({}, obj);
    },
    mergeArrays(arr) {
      Object.entries(arr).forEach(([outerKey, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          this.doc[outerKey][key] = value;
        });
      });
    },
    closeDialog() {
      this.dialog = false;
    },
    handleEnd() {
      this.doAutoSave();
    },
    doAutoSave() {
      if (this.autoSave) {
        this.saveState = true;
      }
    },
  },
};
</script>

<style lang="scss"></style>
